/* eslint-disable max-len */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseTransformNode from '@appblocks/codegeneration/Nodes/DataTransformations/BaseTransformNode';

export default class AbsoluteValueNode extends BaseTransformNode {
    constructor() {
        super();
        this.name = 'Absolute Value';
        this.id = 'node_abs';
        this.functionName = 'absolute_value';
        this.inputDataType = TibboDataType.FLOAT;
        this.outputDataType = TibboDataType.FLOAT;
        this.setPorts();
    }

    getFunctionBody(): string {
        const code = `
    if input < 0 then
        ${this.functionName} = input * -1
    else
        ${this.functionName} = input
    end if`;
        return code;
    }
}
